import FetchWrapper from '@mv-submodules/inplant-coreadapter-fe/functions/fetch-wrapper'

export const API = () => FetchWrapper.getInstance('plantHalts')
